const convertVeiculoTipoToFipe = (tipo) => {
  const tipos = {
    "carro":1,
    "moto":2,
    "caminhao":3,
  }
  return tipos[tipo];
}

export default convertVeiculoTipoToFipe